<template src="./importexcel.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";
  import {
    XlsxRead,
    XlsxTable,
    XlsxSheets,
    XlsxJson,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  } from "vue-xlsx/dist/vue-xlsx.es.js"; // https://vue-xlsx.netlify.app/guide/#quick-start

  export default {
    components: {
      XlsxRead,
      XlsxTable,
      XlsxSheets,
      XlsxJson,
      XlsxWorkbook,
      XlsxSheet,
      XlsxDownload,
    },
    filters: {},
    data() {
      return {
        trailersModule: false,
        assetsModule: false,
        fuelTrackingModule: false,
        ShowLoader: false,
        SubmittedDriver: false,
        SubmittedVehicle: false,
        SubmittedAsset: false,
        SubmittedTrailer: false,
        SubmittedFuel: false,
        SubmittedDriverRes: [],
        SubmittedVehicleRes: [],
        SubmittedAssetRes: [],
        SubmittedTrailerRes: [],
        SubmittedFuelRes: [],
        fileVehicle: null,
        fileAsset: null,
        fileDriver: null,
        fileTrailer: null,
        fileFuel: null,
        selectedSheet: "Sheet1",
        sheetName: null,
        sheets: null,
        collection: null,
      };
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Import Excel";
      this.GetCompanySubscription();
    },

    methods: {
      GetCompanySubscription() {
        var FleetSubscriptionModules = JSON.parse(
          JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
        );
        const isTrailer = FleetSubscriptionModules.Trailers;
        if (isTrailer) {
          this.trailersModule = true;
        }
        const isAsset = FleetSubscriptionModules.Assets;
        if (isAsset) {
          this.assetsModule = true;
        }
        const isFuelTracking = FleetSubscriptionModules["Fuel Tracking"];
        if (isFuelTracking) {
          this.fuelTrackingModule = true;
        }
      },
      onChangeVehicle(event) {
        this.fileVehicle = event.target.files ? event.target.files[0] : null;
        $("#VehicleFileOutput").show();
        this.SubmittedVehicleRes = [];
      },
      onChangeAsset(event) {
        this.fileAsset = event.target.files ? event.target.files[0] : null;
        $("#AssetFileOutput").show();
        this.SubmittedAssetRes = [];
      },
      onChangeDriver(event) {
        this.fileDriver = event.target.files ? event.target.files[0] : null;
        $("#DriverFileOutput").show();
        this.SubmittedDriverRes = [];
      },
      onChangeTrailer(event) {
        this.fileTrailer = event.target.files ? event.target.files[0] : null;
        $("#TrailerFileOutput").show();
        this.SubmittedTrailerRes = [];
      },
      onChangeFuel(event) {
        this.fileFuel = event.target.files ? event.target.files[0] : null;
        $("#FuelFileOutput").show();
        this.SubmittedFuelRes = [];
      },
      parsFunc(event) {
        console.log(event);
      },
      ImportVehicleSubmit(collection) {
        console.log("Vehicles Collection", collection);
        this.SubmittedVehicle = true;
        Axios.post(Endpoints.ImportExcel.Vehicles, {
          token: localStorage.getItem("token"),
          vehicles: collection,
        }).then((Response) => {
          this.SubmittedVehicle = false;
          this.SubmittedVehicleRes = Response.data.message;
          //this.$swal("Drivers Saved Successfully", "", "success").then(() => {});
        });
      },
      ImportAssetSubmit(collection) {
        console.log("Assets Collection", collection);
        this.SubmittedAsset = true;
        Axios.post(Endpoints.ImportExcel.Assets, {
          token: localStorage.getItem("token"),
          assets: collection,
        }).then((Response) => {
          this.SubmittedAsset = false;
          this.SubmittedAssetRes = Response.data.message;
        });
      },
      ImportDriverSubmit(collection) {
        console.log("Driver Collection", collection);
        this.SubmittedDriver = true;
        Axios.post(Endpoints.ImportExcel.Drivers, {
          token: localStorage.getItem("token"),
          drivers: collection,
        }).then((Response) => {
          this.SubmittedDriver = false;
          this.SubmittedDriverRes = Response.data.message;
          //this.$swal("Drivers Saved Successfully", "", "success").then(() => {});
        });
      },
      ImportTrailerSubmit(collection) {
        console.log("Trailer Collection", collection);
        this.SubmittedTrailer = true;
        Axios.post(Endpoints.ImportExcel.Trailers, {
          token: localStorage.getItem("token"),
          trailers: collection,
        }).then((Response) => {
          this.SubmittedTrailer = false;
          this.SubmittedTrailerRes = Response.data.message;
          //this.$swal("Drivers Saved Successfully", "", "success").then(() => {});
        });
      },
      ImportFuelSubmit(collection) {
        console.log("Fuel Collection", collection);
        this.SubmittedFuel = true;
        Axios.post(Endpoints.ImportExcel.Fuel, {
          token: localStorage.getItem("token"),
          fuels: collection,
        }).then((Response) => {
          this.SubmittedFuel = false;
          this.SubmittedFuelRes = Response.data.message;
          //this.$swal("Drivers Saved Successfully", "", "success").then(() => {});
        });
      },
      ClearDataVehicle() {
        this.fileVehicle = null;
        this.SubmittedVehicleRes = [];
        $("#VehicleFile").val("");
        $("#VehicleFileOutput").hide();
      },
      ClearDataAsset() {
        this.fileAsset = null;
        this.SubmittedAssetRes = [];
        $("#AssetFile").val("");
        $("#AssetFileOutput").hide();
      },
      ClearDataDriver() {
        this.fileDriver = null;
        this.SubmittedDriverRes = [];
        $("#DriverFile").val("");
        $("#DriverFileOutput").hide();
      },
      ClearDataTrailer() {
        this.fileTrailer = null;
        this.SubmittedTrailerRes = [];
        $("#TrailerFile").val("");
        $("#TrailerFileOutput").hide();
      },
      ClearDataFuel() {
        this.fileFuel = null;
        this.SubmittedFuelRes = [];
        $("#FuelFile").val("");
        $("#FuelFileOutput").hide();
      },
    },
  };
</script>

<style type="text/css">
  .exceltable td,
  .exceltable th {
    border: 1px solid #dfe2e5;
    padding: 0.6em 1em;
  }
</style>
